import { isEmptyValue } from 'aa_common/front-end/helpers'
import { useCallback } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

export const useSetDefaultFormValue = <T extends string | number>(
  fieldName: string,
  defaultValue: T,
  shouldSetDefault?: boolean
) => {
  const { setValue } = useFormContext()
  const formValue = useWatch<T>({ name: fieldName })

  return useCallback(() => {
    if (isEmptyValue(formValue) && shouldSetDefault) {
      setValue(fieldName, defaultValue, { shouldValidate: true })
    }
  }, [fieldName, formValue, shouldSetDefault, setValue])
}
